import React from "react"
import { Group, Source } from "@mui/icons-material"
import { Scopes } from "utils/authUtils"
import { USER_ROLE } from "./application"


export const USER_ROLE_FILTERS = {
  all: 'Todas',
  compliance: 'Compliance',
  hr: 'Recursos Humanos',
  admin: 'Administrador',
  adminReadOnly: 'Apenas Leitura',
  accessManager: USER_ROLE.accessManager,
  recruitersApi: USER_ROLE.recruitersApi,
}

export const USER_AUTH_METHODS = {
  SSO: 'SSO',
  PASSWORD: 'Senha',
}

export const USER_AUTH_METHOD_LABELS = {
  [USER_AUTH_METHODS.SSO]: 'SSO',
  [USER_AUTH_METHODS.PASSWORD]: 'Usuário + Senha',
}


export const USER_AUTH_METHOD_DESCRIPTIONS = {
  [USER_AUTH_METHODS.SSO]: 'O usuário precisa estar cadastrado no AD e só poderá se autenticar via SSO.',
  [USER_AUTH_METHODS.PASSWORD]: 'O usário precisa ter um login e senha válidos para se autenticar no sistema. Não poderá usar SSO.',
  [USER_AUTH_METHODS.TEMPORARY_PASSWORD]: 'Acesso Temporário',
}

export const USER_ROLE_LABELS = {
  [USER_ROLE.accessManager]: 'Gestor de Acessos',
}

export const USER_ROLE_DESCRIPTION = {
  [USER_ROLE.hr]: 'Pode ver e decidir sobre apontamentos derivados para o time de Recursos Humanos.', 
  [USER_ROLE.compliance]: 'Pode ver e decidir sobre apontamentos derivados para o time de Compliance.', 
  [USER_ROLE.admin]: 'Pode ver e decidir sobre apontamentos das áreas de Recursos Humanos e Compliance.',
  [USER_ROLE.adminReadOnly]: 'Pode ver os apontamentos das áreas de Recursos Humanos e Compliance, mas não pode tomar decisões.', 
  [USER_ROLE.accessManager]: 'Pode criar e editar acessos de usuários e visualizar o Monitor de Usuários, sem acesso às funcionalidades de negócio do sistema.',
  [USER_ROLE.recruitersApi]: 'Pode criar Aplicações e Background Checks e visualizar Revisões Manuais de RH e Compliance.', 
}

export const USER_ROLE_PERMISSIONS_SUMMARY = {
  [USER_ROLE.hr]: ['Ver todas as Aplicações e Background Checks', 'Criar Background Checks sob demanda', 'Ver e analisar Revisões Manuais de RH'],
  [USER_ROLE.compliance]: ['Ver todas as Aplicações e Background Checks', 'Criar Background Checks sob demanda', 'Ver e analisar Revisões Manuais de Compliance'],
  [USER_ROLE.admin]: ['Ver todas as Aplicações e Background Checks', 'Criar Background Checks sob demanda', 'Ver e analisar Revisões Manuais de RH', 'Ver e analisar Revisões Manuais de Compliance', 'Configurar opções restritivas', 'Criar/editar acessos de usuários'],
  [USER_ROLE.adminReadOnly]: ['Ver todas as Aplicações e Background Checks', 'Apenas ver Revisões Manuais de RH', 'Apenas ver Revisões Manuais de Compliance', 'Apenas ver opções restritivas', 'Apenas ver a lista de usuários'],
  [USER_ROLE.accessManager]: [
    'Criar/editar acessos de usuários',
    'Visualizar o Monitor de Usuários',
    'Não tem acesso a funcionalidades de lógica de negócios do sistema',
  ],
  [USER_ROLE.recruitersApi]: ['Ver todas as Aplicações e Background Checks', 'Criar Background Checks sob demanda', 'Ver e alterar as configurações de lógica de negócios (Opções Restritivas)', 'Apenas ver Revisões Manuais de RH e Compliance', 'É um usuário de API, não pode acessar o painel'],
}

export const USER_PERMISSION = {
  [Scopes.OPTIONS_MANAGEMENT]: 'Gerenciar Base de Opções Restritivas',
  [Scopes.USER_MANAGEMENT]: 'Gerenciar Acesso de Usuários',
  [Scopes.USER_MANAGEMENT_LIST_USERS]: 'Listar Usuários',
  [Scopes.USER_MANAGEMENT_EDIT_USER]: 'Editar Usuário',
}

export const getUserPermissionIcon = (scope, fontSize = 'medium') => {
  const icons = {
    [Scopes.OPTIONS_MANAGEMENT]: <Source fontSize={fontSize}/>,
    [Scopes.USER_MANAGEMENT]: <Group fontSize={fontSize} />,
    [Scopes.USER_MANAGEMENT_LIST_USERS]: <Group fontSize={fontSize} />,
    [Scopes.USER_MANAGEMENT_EDIT_USER]: <Group fontSize={fontSize} />,
  }
  return icons[scope]
}
